import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=7ad61c33&scoped=true"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad61c33",
  null
  
)

export default component.exports